
import Vue from 'vue';
import BaseIcon from '../BaseIcon.vue';
import BaseButton from '../BaseButton.vue';
import { AlertComponentProps, Button, EventDataWithLinkTitle, EventDataWithoutLinkTitle, EventEmitData } from './types';
import LinkHandler from '../../helpers/LinkHandler.vue';

type Props = AlertComponentProps;

interface Data {
  isFadeActive: boolean;
  iconsMapping: Record<string, string>;
}

interface Methods {
  removeFade: () => void;
  triggerFadeAnimation: () => void;
  close: () => void;
  handleButtonClick: (button: Button) => void;
  getButtonHref: (button: Button) => Button['href'];
  fadeAnimationEnd: () => void;
  closeButtonHandler: () => void;
  trackEvent: (data: EventDataWithLinkTitle | EventDataWithoutLinkTitle) => void;
}

export default Vue.extend<Data, Methods, unknown, Props>({
  components: {
    BaseIcon,
    BaseButton,
    LinkHandler,
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    text: {
      type: String,
      required: false,
    },
    link: {
      type: Object,
      required: false,
    },
    type: {
      type: String as () => Props['type'],
      required: false,
    },
    buttons: {
      type: Array,
      required: false,
    },
    fadeTrigger: {
      type: Number,
      required: false,
    },
    closeCallback: {
      type: Function,
      required: false,
    },
    closeButton: {
      type: Boolean,
      required: false,
      default: true,
    },
  },
  data() {
    return {
      isFadeActive: false,
      iconsMapping: {
        info: 'fa-regular fa-circle-info',
        warning: 'fa-regular fa-circle-exclamation',
        error: 'fa-regular fa-circle-xmark',
        success: 'fa-regular fa-circle-check',
      },
    };
  },
  mounted() {
    this.triggerFadeAnimation();
    this.trackEvent({
      eventType: 'view',
    });
  },
  methods: {
    removeFade() {
      this.isFadeActive = false;
    },
    trackEvent(data) {
      const emitData: EventEmitData = {
        title: this.title,
        ...data,
      };

      this.$emit('track-event', emitData);
    },
    triggerFadeAnimation() {
      if (this.fadeTrigger) {
        setTimeout(() => {
          this.isFadeActive = true;
        }, this.fadeTrigger);
      }
    },
    handleButtonClick(button) {
      if (button.action) {
        button.action();
      }

      this.trackEvent({
        eventType: 'click',
        linkTitle: button.text,
      });

      this.close();
    },
    getButtonHref(button) {
      return button.href;
    },
    fadeAnimationEnd() {
      this.trackEvent({
        eventType: 'hide',
      });

      this.close();
    },
    closeButtonHandler() {
      this.trackEvent({
        eventType: 'click',
        linkTitle: 'X',
      });

      this.close();
    },
    close() {
      if (this.closeCallback) {
        this.closeCallback();
      }

      this.$emit('close');
    },
  },
});
